import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { AutoComplete, ISelectType } from "@4uhub/lib4uhub";
import { Box, Grid, Tooltip } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import MainApi from "../../../../../../../services/mainApi.service";

const translationPath = "page.4uMarCom.automationRules.marcom_message.";

const TICKET_AUTOMATION_RECEIVED_RULE_ROUTE =
  process.env.REACT_APP_AUTOMATIONS + "/api/v1/TicketAutomationReceivedRule/";

const ticketAutomationReceivedRuleService = new MainApi(
  TICKET_AUTOMATION_RECEIVED_RULE_ROUTE,
);

export const TicketAutomationReceivedRuleMessagesMarcom = memo(() => {
  const { t } = useTranslation();

  return (
    <Grid item xs={12} sm={12}>
      <Box display="flex" alignItems="center" gap={1}>
        <Box flex={1}>
          <AutoComplete
            getOptionLabel={({ name }: ISelectType) => name}
            size="small"
            fullWidth
            label={t(translationPath + "ticket_automation_received_rule")}
            name="ticketAutomationReceivedRule"
            request={ticketAutomationReceivedRuleService.list}
          />
        </Box>
        <Tooltip
          title={t(translationPath + "ticket_automation_received_rule_info")}
          arrow
          placement="top"
        >
          <InfoOutlinedIcon
            fontSize="small"
            color="action"
            sx={{ cursor: "pointer" }}
          />
        </Tooltip>
      </Box>
    </Grid>
  );
});
